import isArray from 'lodash/isArray';
import isFunction from 'lodash/isFunction';
import flow from 'lodash/flow';
import { getLimit, toDom } from './utils';
import dom from '../../wrapper/DomWrapper';
import { getDeviceType } from '../../helpers/browser';

class Pagination {
  static events = {
    onInit: 'init',
    onChange: 'change',
  };

  lastMeta = null;

  // DOMElement - current pager
  pager = null;

  state = { isLoading: false };

  handlers = {
    [Pagination.events.onChange]: [],
    [Pagination.events.onInit]: [],
  };

  constructor(options, container, renderer) {
    this.options = options;
    this.renderer = renderer;
    this.container = container;

    const limit = getLimit(this.options.itemSize, this.options, getDeviceType());
    this.setState('limit', limit);
  }

  getTemplateData = (data) => data;

  attachListeners = (DOM) => DOM;

  render = (meta = this.lastMeta) => {
    if (!meta) return;

    this.lastMeta = meta;

    const { selector } = this.options;
    const render = flow(
      this.getTemplateData,
      this.renderer.render,
      toDom,
      this.attachListeners,
    );
    const next = render(meta);
    const current = dom.getElement(selector);

    if (!current) {
      this.container.appendChild(next);
    } else {
      current.parentNode.replaceChild(next, current);
    }

    this.onDidMount(next);
    this.pager = next;
  };

  setPage = (pageNum) => {
    const { limit } = this.state;
    const offset = pageNum * limit;

    this.setState('isLoading', true);

    if (this.pager) { this.pager.style.pointerEvents = 'none'; }

    this.fireEvent(Pagination.events.onChange, { limit, offset });
  };

  on = (event, handler) => {
    const events = isArray(event) ? event : [event];
    events.forEach((_event) => this.addHandler(_event, handler));
  };

  addHandler = (event, handler) => {
    if (!this.handlers[event] || this.handlers[event].includes(handler)) return;

    this.handlers[event].push(handler);
  };

  fireEvent = (event, data) => {
    if (!this.handlers[event] || !this.handlers[event].length) return;

    this.handlers[event].forEach((handler) => {
      if (!isFunction(handler)) return;

      handler(data, event);
    });
  };

  // eslint-disable-next-line no-return-assign
  setState = (key, value) => this.state[key] = value;

  onDidMount = () => {};

  remove = () => {
    try {
      this.pager.parentNode.removeChild(this.pager);
      // eslint-disable-next-line no-empty
    } catch (e) {}
  };
}

export default Pagination;
